import React from 'react';
import { NavLink } from 'react-router-dom';

const NotFound = () => (
  <section className="displayed-content">
    <h2>Page Not Found</h2>
    <p>Oh no, this is embarrassing. There is nothing to see here.</p>
    <NavLink
      title="Return to home page."
      exact to="/">Click here to go back to homepage.
        </NavLink>
  </section>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js